import * as React from 'react';
import { observer } from 'mobx-react';
import { Pagination } from 'antd';
import { resolve } from 'inversify-react';

import { IStackTraceMessage } from 'src/app/rules/rules/rule-services';
import { FormatService } from "src/core/services/format.service";
import { TruncatedTextView } from 'src/app/rules/rules/stacktrace/parts/truncated-text.view';

interface RuleStackTraceListProps {
	items: { [sessionId: string]: IStackTraceMessage[] };
	item: RuleItem;
	total: number;
	pageIndex: number;
	pageSize: number;
	onPageChange: (index: number) => void;
}

@observer
export class TraceSessionView extends React.Component<{ traces: IStackTraceMessage[], session: string }, { collapsed: boolean }> {

	@resolve
	formatService: FormatService;

	constructor(props) {
		super(props);

		this.state = {
			collapsed: false
		}
	}

	getLogColor(level?: number) {
		switch (level) {
			case 0:
			case 1:
				return 'red';
			case 2:
				return 'green';
			case 3:
				return 'blue';
			default:
				return 'black';
		}
	}

	renderSession(session: string, items: IStackTraceMessage[]) {
		return (
			<div style={{ margin: '10px' }} key={"session" + session}>
				<div style={{ margin: '10px', backgroundColor: 'rgba(0,0,0,0.05)', color: 'black', padding: '5px' }} >
					<h3 style={{ marginBottom: '3px', cursor: 'pointer' }} onClick={() => this.setState({ collapsed: !this.state.collapsed })}>Session id: {session}</h3>
					{!this.state.collapsed && items.map((item: IStackTraceMessage, index) => {
						return (
							<div style={{ marginBottom: '2px', fontSize: '9pt' }} key={"log" + index + session}>
								<TruncatedTextView
									header={<strong style={{ color: this.getLogColor(item.level), marginRight: '5px' }}>[{this.formatService.toString("small-full-date-time", item.date)}]</strong>}
									maxSize={100}
									value={item.header}
								/>
							</div>
						);
					})}
				</div>
			</div>
		);
	}

	render() {
		return this.renderSession(this.props.session, this.props.traces);
	}
}

@observer
export class RuleStackTraceList extends React.Component<RuleStackTraceListProps, any> {
	render() {
		return (
			<div>
				{this.props.item != null && <h2> Rule Stacktrace:  {this.props.item.name}</h2>}
				{Object.keys(this.props.items).map((k) => <TraceSessionView key={k} session={k} traces={this.props.items[k]} />)}
				<Pagination
					onChange={page => {
						this.props.onPageChange(page - 1);
					}}
					current={this.props.pageIndex + 1}
					total={this.props.total}
					pageSize={this.props.pageSize}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/stacktrace/rule-stacktrace-list.view.tsx